<template>
  <img class="pt2" :src="localizedFilename(lang).img" :alt="localizedFilename(lang).alt">
</template>

<script>
export default {
  props: ['lang'],

  data () {
    return {
      images: {
        ru: require('../assets/logotype/SavePolesia_logo-RU.png'),
        en: require('../assets/logotype/SavePolesia_logo-EN.png')
      }
    }
  },

  methods: {
    localizedFilename (lang) {
      let img = this.images.en
      let alt = 'Save Polesia Logotype'
      if (lang === 'ru') {
        alt = 'Логотип Сохраним Полесье'
        img = this.images.ru
      }
      return {img: img, alt: alt}
    }
  }
}
</script>

<style scoped>
img {
  max-width: 9em;
}

.small {
  max-width: 5em;
}
</style>



// WEBPACK FOOTER //
// Logotype.vue?7e17f1f0